import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'
import { ModalBodyTableSortProps } from '@ui/components/Modal/Body/Table/Sort'

interface Props extends ModalBodyTableSortProps {
  title?: string
  description?: string
}

export const SortModal: BaseModalType<Props> = (props) => {
  const { close, description, options, onConfirm } = props
  const { t } = useTranslation()
  const { title = t('Sort by') } = props

  return (
    <Modal.FullScreen>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        {description && <Modal.Body.Text>{description}</Modal.Body.Text>}
        <Modal.Body.Table.Sort
          options={options}
          onConfirm={(option, sortBy, sortName) => {
            onConfirm(option, sortBy, sortName)
            close()
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Close')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal.FullScreen>
  )
}
